<template>
  <div class="calc">
    <b-container>
      <b-row>
        <b-col sm class="text-center">
          <h2><span style="color:green; font-weight: bold;">Congrats!</span> You are approved for your car repair loan!</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <b-row>

            <b-col sm>
              <h3 v-show="cashStatus">Cash amount required: {{cashReady}}$</h3>
              <h3>Repair amount: {{repairAmount}}$</h3>
              <h3><span style="color:green;">Approved amount:</span> {{boundaryLimit}}$</h3>

              <!-- Loan amount and Pay by Cash titles -->
            </b-col>
          </b-row>

          <b-row align-h="between" class="mt-3">
            <b-col sm="12" md="12" lg="6">
              <b-row>
                <b-col>
                  <label for="amount" class="text-muted">Loan Amount</label>

                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <input id="amount" v-model="finalLoanAmount" type="text">

                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="12" lg="6">
              <b-row>
                <b-col>
                  <label for="cash-amount" class="text-muted text-right">Debit\Credit</label>

                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <input id="cash-amount" v-model="updateRatio" type="text">

                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- Loan range -->
          <b-row>
            <input v-model="finalLoanAmount" type="range" class="custom-range mt-3 mb-2" min="500" :max="boundaryLimit" @input="process()">

          </b-row>

          <b-row align-h="between">
            <b-col cols="4">
              $500
            </b-col>
            <b-col cols="4" class="text-right">
              ${{boundaryLimit}}
            </b-col>
          </b-row>
          <!-- term range -->
          <b-row class="mt-3">
            <label for="term" class="text-muted">Term</label>
          </b-row>
          <b-row>
            <span class="resultText text-left">{{term}} months</span>
          </b-row>
          <b-row>
            <input id="term" v-model="term" type="range" class="custom-range mb-2  mt-3" step="6" min="12" max="24" @input="process()">
          </b-row>
          <b-row align-h="between">
            <b-col cols="4" class="min-label">
              12 months
            </b-col>
            <b-col cols="4" class="text-right max-label">
              24 months
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <label for="payments" class="text-muted">Payments</label>
          </b-row>
          <b-row>
            <span class="resultText text-left">{{ paymentsLabel }}</span>
          </b-row>
          <b-row>
            <input id="payments" v-model="paymentType" type="range" class="custom-range  mb-2  mt-3" min="0" max="3" @input="process()">
          </b-row>
          <b-row align-h="between">
            <b-col v-for="item in paymentsLabels" :key="item" cols="2">
              {{ item }}
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="12" lg="4" class="text-center my-auto ">
          <div class="result-box">
            <div v-if="seen" class="spinner-border text-success" role="status">
    <span class="sr-only">Loading...</span>
  </div>
            <!-- <Loading v-if="seen" color="purple" /> -->
            <template v-else>
              <span class="text">Your {{paymentsLabel}} payments</span>
              <span class="result">${{calcPayment}} </span>
              <span class="text">For a period of {{term}} months</span>
              <b-col>
                <span style="padding-right:3px; padding-top: 3px; display:inline-block;">
                </span>
              </b-col>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Loading from './loading'

let timeout = null

export default {
  name: 'NewCalc',
  components: {
    Loading,
  },
  data() {
    return {
      title: 'Your payment would be',
      paymentsLabels: ['Weekly', 'Bi-weekly', 'Semi-monthly', 'Monthly'],
      seen: false,
      amount: '',
      finalLoanAmount: '',
      repairAmount: '',
      paymentType: '0',
      approvedLoan: '',
      loanRatio: '',
      minimumLoan: '',
      maxLoanAmount: '',
      price: '',
      term: '12',
      term_type: 'months',
      rate: '29.9',
      cashStatus: false,
    }
  },
  computed: {
    // fees calculation
    fees: function() {
      return this.term > 12 ? 128 : 128
    },
    calcPayment: function(e) {
      const paymentPeriod = [4.34524, 2.17262, 2, 1]
      const perYear = paymentPeriod[this.paymentType]
      var p = parseFloat(this.finalLoanAmount) + parseFloat(this.fees)
      var r = this.rate / 1200
      var n = this.term
      var i = Math.pow(1 + r, n)
      var payment = ((p * r * i) / (i - 1) || 0) / perYear
      return payment.toFixed(0)
    },
    cashNeeded: function() {
      return this.maxLoanAmount - this.finalLoanAmount
    },
    paymentsLabel() {
      return this.paymentsLabels[this.paymentType]
    },
    cashReady() {
      if (this.maxLoanAmount < this.repairAmount) {
        this.cashStatus = !this.cashStatus
        return this.repairAmount - this.maxLoanAmount
      } else {
        return (this.cashReady = 500)
      }
    },
    updateRatio() {
      return this.repairAmount - this.finalLoanAmount
    },
  },
  watch: {
    finalLoanAmount() {
      this.$store.state.userData.loanRequested = this.finalLoanAmount
      this.$store.state.userData.payment = this.calcPayment
      this.$store.state.userData.numberOfPayments = this.finalLoanAmount / this.calcPayment
    },

    term() {
      this.$store.state.userData.paymentFrequency = this.paymentsLabel
      this.$store.state.userData.paymentPeriod = `${this.term} months`
      this.$store.state.userData.numberOfPayments = this.finalLoanAmount / this.calcPayment
      this.$store.state.userData.term = this.term
      this.$store.state.userData.payment = this.calcPayment
    },
    paymentType() {
      this.$store.state.userData.payment = this.calcPayment
      this.$store.state.userData.numberOfPayments = this.finalLoanAmount / this.calcPayment
      this.$store.state.userData.paymentFrequency = this.paymentsLabel
    },
  },

  created() {
    this.currentYear = new Date().getFullYear()
    this.loanRatio = 1 - (this.currentYear - this.$store.state.userData.year)/35
    this.approvedLoan = Math.max(1500,(Math.trunc((this.$store.state.userData.marketValue * 0.3 * 0.7) * this.loanRatio)))
    this.repairAmount = this.$store.state.userData.repairOfferAmount
    // Check the maximum amount possible to take if the approved loan is lower than the repair offer
    this.maxLoanAmount =
      this.approvedLoan > this.repairAmount ? this.repairAmount : this.approvedLoan

    this.boundaryLimit = this.maxLoanAmount > 10000 ? 10000 : this.maxLoanAmount
    // Check if the customer needs to bring cash because his approved amount doesn't cover the repair offer
    this.minimumLoan =
      this.approvedLoan > this.repairAmount ? 500 : this.repairAmount - this.approvedLoan
    // set default highest loan possible
    this.finalLoanAmount = this.boundaryLimit
    // store the data
    this.$store.state.userData.boundaryAmount = this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    this.$store.state.userData.payment = this.calcPayment
    this.$store.state.userData.paymentTotal = this.finalLoanAmount
    this.$store.state.userData.paymentFrequency = this.paymentsLabel
    // is the below line important?
    this.$store.state.userData.paymentPeriod = `${this.term} months`
    this.$store.state.userData.term = this.term
  },
  beforeMount() {
    this.$store.state.userData.approvedLoanAmount = this.approvedLoan
  },
  methods: {
    // Two function for the spinner
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
  },
}
</script>

<style scoped>
.calc input[type='text'] {
  border: 1px solid #ccc;
  width: 150px;
  text-align: center;
  outline: none;
  font-size: 24px;
  padding: 5px;
  border-radius: 2rem;
  color: #c40bb1;
  font-weight: 700;
}

.resultText {
  font-size: 24px;
  padding: 5px;
  border-radius: 2rem;
  color: #c40bb1;
  font-weight: 700;
}

.calc input[type='range'] {
  margin-bottom: 30px;
}

.calc .term span,
.calc .payments span {
  font-size: 24px;
  color: #c40bb1;
  font-weight: 700;
}

.calc .amount .labels,
.calc .term .labels {
  position: relative;
  color: #dedcd9;
}

.calc .amount .labels .min-label,
.calc .term .labels .min-label {
  position: absolute;
  top: -20px;
  left: 0;
}

.calc .amount .labels .max-label,
.calc .term .labels .max-label {
  position: absolute;
  top: -20px;
  right: 0;
}

.calc .payments .labels {
  position: relative;
  color: #dedcd9;
}

.calc .payments .labels div {
  position: absolute;
  top: -20px;
}

.calc .payments .labels div:nth-child(1) {
  left: 0;
}

.calc .payments .labels div:nth-child(2) {
  left: 33.333%;
  transform: translateX(-50%);
}

.calc .payments .labels div:nth-child(3) {
  left: 66.666%;
  transform: translateX(-50%);
}

.calc .payments .labels div:nth-child(4) {
  right: 0;
}

.result-box {
  height: 100%;
  margin-top: 3rem;
}

.result-box .text {
  font-size: 18px;
  color: #707070;
}

.result-box .result {
  font-size: 24px;
  font-weight: 700;
  color: #c40bb1;
}

input[type='range']::-webkit-slider-runnable-track {
  height: 4px;
}

input[type='range']::-moz-range-track {
  height: 4px;
}

input[type='range']::-ms-track {
  height: 4px;
}

input[type='range']::-webkit-slider-thumb {
  margin-top: -0.4rem;
}

input[type='range']::-moz-range-thumb {
  margin-top: -0.4rem;
}

input[type='range']::-ms-thumb {
  margin-top: -0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/new_calc.vue